import type { SVGProps } from "react";
import * as React from "react";
const SvgContactsRobot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 22H6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h15v20ZM6 18a1 1 0 1 0 0 2h13v-2H6Zm6-7a3 3 0 0 0-3 3h6a3 3 0 0 0-3-3Zm-2-5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-4Zm.75 1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm2.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
    />
  </svg>
);
export default SvgContactsRobot;
